import { User } from '../types/authTypes';
import { Investor } from '../types/investorTypes';

export function updateAccountOptions(investor: Investor) {
  const user = JSON.parse(localStorage.getItem('user') || '{}') as User;
  if (user.Id === investor.Id) {
    user.AccountInfo.AccountOptions = investor.AccountOptions;
    user.AccountOptions = investor.AccountOptions;
    localStorage.setItem('user', JSON.stringify(user));
  }
}
